<template>
	<li :class="{big,highlight,'paid-feature' : isPaidFeature}">
		<a v-if="linkIsExternal" :href="link" :class="classes">
			<i class="fa fa-fw" :class="icon"></i>
			<span v-if="!iconOnly">{{text}}</span>
		</a>
		<router-link v-else-if="linkLocal" :to="linkLocal" :class="classes" :title="text" :disabled="true">
			<i class="fa fa-fw" :class="icon"></i>
			<span v-if="!iconOnly">{{text}}</span>
		</router-link>
		<a v-else-if="click || !linkLocal" href="#" v-on:click="itemClick">
			<i class="fa fa-fw" :class="icon"></i>
			<span v-if="!iconOnly">{{text}}</span>
		</a>
		
		<slot></slot>
		<hr v-if="big">
	</li>

</template>

<script type="text/javascript">
	export default {
		name: "NavItem",
		props: ["icon","link","click","text","big","classes","iconOnly","highlight","isPaidFeature"],
		computed: {
			linkIsExternal() {
				if (this.link && this.link.search("http") >= 0)
					return true
				return false
			},
			linkLocal() {
				if (this.link) {
					if (this.isPaidFeature && this.isFreemiumUser)
						return false
					else
						return this.link
				}
				else
					return false
			}
		},
		methods: {
			itemClick(click) {
				if (this.isPaidFeature && this.isFreemiumUser) {
					this.throwPremiumFeatureError()
				}
				else
					this.$emit('click',this.click)
			}
		}
	}
</script>

<style type="text/css" scoped>

	/*
	li {
		min-width: 250px;
	}
	*/

	a {
		display: block;
		padding: 10px;
		padding-top: 6px;
		padding-bottom: 6px;
		color: inherit;
		text-decoration: none;
		font-size: 12pt;
		font-weight: 600;
		border-radius: 3px;
	}


	li {
		position: relative;
	}

	li i {
		color: var(--brand-primary-color-faded);
	}

	.fa {
		margin-right: 18px;
		margin-left: 8px;
	}

	a:hover, a:hover i {
		text-decoration: none;
		background-color: #788e98;
	}

	.big .fa {
		font-size: 2.5em;
		margin-right: 2px;
		margin-left: -8px;
	}

	.big span {
		position: relative;
		top: -5px;
	}

	.highlight {
		background-color: var(--brand-primary-color);
		color: white;
		border-radius: 10px;
	}

	hr {
		margin: 0;
	}

	@media (max-width: 500px) {
		li {
			flex-basis: calc(50% - 10px);
			display: block;
			text-align: center;
			margin: 5px;
			min-width: 0;
		}

		li.big {
			flex-basis: 100%;
		}

		li i.fa, li.big i.fa {
			display: block;
			margin:auto;
			font-size: 24pt;
		}

		li span {
			display: block;
		}

		a {
			padding-top: 12px;
			padding-bottom: 12px;
			height: 100%;
			width: 100%;
			background-color: #67707f;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.highlight a {
			background-color: #2d37489e;
		}

	}

</style>